import { useState, useCallback } from 'react';
import {
  generateText,
  type TextGenerateResponse,
} from '@/components/v2/tools/text/textGenerationApi';

export interface GenerateArgs {
  productId: string;
  fieldType: string;
  templateId?: string;
  presetId?: string;
  imageKey?: string;
  channelId?: string;
  systemToolCode?: string;
}

/** Drives a single product-field AI generation (preview, no write-back yet). */
export function useAIFieldGeneration() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<TextGenerateResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async (args: GenerateArgs) => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const resp = await generateText({
        tool_code: '',
        prompt: '',
        product_id: args.productId,
        field_type: args.fieldType,
        template_id: args.templateId,
        preset_id: args.presetId,
        image_key: args.imageKey,
        channel_id: args.channelId,
        system_tool_code: args.systemToolCode,
      });
      if (resp.success) setResult(resp);
      else setError(resp.error || 'generation_failed');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'generation_failed');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { generate, reset, loading, result, error };
}
